import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'
import {
  openApiFetchAuthMiddleware,
  type AuthorizationMiddlewareOptions,
} from '@omnea-app/packages/universal/open-api-fetch/openApiFetchAuthMiddleware'
import { paths } from './auctionsGeneratedTypes'

export type AuctionsResponse<T extends keyof paths, M extends keyof paths[T]> = GenericResponse<paths, T, M>
export type AuctionsApiRequestBody<T extends keyof paths, M extends keyof paths[T]> = GenericRequestBody<paths, T, M>

export type AuctionResponse = paths['/{auctionId}']['get']['responses']['200']['content']['application/json']
export type AuctionStateResponse = paths['/{auctionId}/state']['get']['responses']['200']['content']['application/json']
export type ListAuctionSuppliersResponse =
  paths['/{auctionId}/suppliers']['get']['responses']['200']['content']['application/json']
export type UpdateAuctionSettingsRequest = NonNullable<
  paths['/{auctionId}/settings']['post']['requestBody']
>['content']['application/json']
export type AddAuctionSupplierRequest = NonNullable<
  paths['/{auctionId}/suppliers']['post']['requestBody']
>['content']['application/json']

type Options = {
  authorization: AuthorizationMiddlewareOptions
}

export class AuctionsHttpClient {
  GET
  POST

  constructor({ authorization }: Options) {
    const client = createClient<paths>({ baseUrl: ServiceUrls.AUCTIONS })

    client.use(openApiFetchAuthMiddleware(authorization))

    this.GET = withErrorCapture({ method: client.GET })
    this.POST = withErrorCapture({ method: client.POST })
  }
}
